import { render, staticRenderFns } from "./support_ticket_contacts_modal.vue?vue&type=template&id=80821636&scoped=true&"
import script from "./support_ticket_contacts_modal.vue?vue&type=script&lang=js&"
export * from "./support_ticket_contacts_modal.vue?vue&type=script&lang=js&"
import style0 from "./support_ticket_contacts_modal.vue?vue&type=style&index=0&id=80821636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80821636",
  null
  
)

export default component.exports